import ContactDto from '@/models/Contacts/ContactDto';
import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';
import LocationDto from '@/models/Locations/LocationDto';

export default class ContactLocationDto extends BaseAgencyScopeEntityDto {
    contactId: string;
    contact: ContactDto = new ContactDto();
    locationId: string;
    location: LocationDto = new LocationDto();
}